import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ThemeToggle from '../components/ThemeToggle';
import api from '../api/client';

export default function DashboardPage() {
  const { user } = useAuth();
  const [solutions, setSolutions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchSolutions();
  }, []);

  async function fetchSolutions() {
    try {
      const res = await api.get('/tasks/my-solutions/');
      setSolutions(Array.isArray(res.data) ? res.data : res.data.results || []);
    } catch {
      setError('Не удалось загрузить данные');
    } finally {
      setLoading(false);
    }
  }

  const totalSolved = solutions.filter((s) => s.status === 'accepted').length;
  const totalSubmissions = solutions.length;
  const acceptanceRate = totalSubmissions > 0
    ? Math.round((totalSolved / totalSubmissions) * 100)
    : 0;

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Загрузка...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-page">
      <div className="page-header dashboard-header-with-toggle">
        <div>
          <h1>Добро пожаловать, {user?.first_name || user?.username}!</h1>
          <p className="page-subtitle">Ваш прогресс обучения</p>
        </div>
        <ThemeToggle />
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-value">{totalSolved}</div>
          <div className="stat-label">Задач решено</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{totalSubmissions}</div>
          <div className="stat-label">Всего попыток</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{acceptanceRate}%</div>
          <div className="stat-label">Процент успеха</div>
        </div>
      </div>

      <div className="dashboard-sections">
        <section className="dashboard-section">
          <h2>Последние решения</h2>
          {solutions.length === 0 ? (
            <div className="empty-state">
              <p>У вас пока нет решений</p>
              <Link to="/catalog" className="btn btn-primary">Открыть каталог задач</Link>
            </div>
          ) : (
            <div className="solutions-list">
              {solutions.slice(0, 10).map((sol, i) => (
                <div key={i} className="solution-item">
                  <div className="solution-info">
                    <span className="solution-task">
                      {sol.task_title || sol.task?.title || `Задача #${sol.task_id || sol.task}`}
                    </span>
                    <span className="solution-date">
                      {sol.created_at ? new Date(sol.created_at).toLocaleDateString('ru-RU') : ''}
                    </span>
                  </div>
                  <span className={`solution-status status-${sol.status}`}>
                    {sol.status === 'accepted' ? '✅ Принято' :
                     sol.status === 'wrong_answer' ? '❌ Неверно' :
                     sol.status === 'error' ? '⚠️ Ошибка' :
                     sol.status || 'На проверке'}
                  </span>
                </div>
              ))}
            </div>
          )}
        </section>

        <section className="dashboard-section">
          <h2>Быстрые действия</h2>
          <div className="quick-links">
            <Link to="/catalog" className="quick-link-card">
              <span className="quick-link-icon">📚</span>
              <span>Каталог задач</span>
            </Link>
            <Link to="/practice-quizzes" className="quick-link-card">
              <span className="quick-link-icon">✅</span>
              <span>Тесты</span>
            </Link>
            <Link to="/collaborative" className="quick-link-card">
              <span className="quick-link-icon">👥</span>
              <span>Совместное кодирование</span>
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}
